import styled from 'styled-components';

import { SkeletonLoader } from '@pkg/components/loaders/SkeletonLoader';
import { styledLayout, styledMedia, styledTypography } from '@pkg/primitives';

export const PriceGroupLoader = styled(SkeletonLoader)<{ $shorter?: boolean }>`
    display: flex;
    border-radius: 8px;
    width: ${({ $shorter }) => ($shorter ? '50px' : '100px')};
`;

export const PriceGroup = styled.div`
    ${styledLayout.fullWidthFix};
    flex-direction: column;
    display: flex;
    gap: 4px;
    flex-grow: 1;
`;

export const PlayerGroup = styled.div`
    flex-direction: column;
    display: flex;
    gap: 1px;
    align-items: flex-end;
`;

export const Label = styled.div`
    font-weight: 500;
    font-size: 11px;
    line-height: 120%;
    letter-spacing: -0.42px;
    color: rgba(255, 255, 255, 0.5);

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: 14px;
    }
`;

export const ContentRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 3px;
`;

export const Content = styled.div`
    ${styledLayout.fullWidthFix};
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    gap: 6px;
`;

const valuePrefixSize = 16;

export const Value = styled.div`
    ${styledLayout.fullWidthFix};
    display: flex;
    gap: 4px;
    align-items: center;
    min-height: ${valuePrefixSize}px;
`;

export const ValuePrefix = styled.div`
    ${styledMedia.iconWrapper};
    padding: 2px;
    width: ${valuePrefixSize}px;
    height: ${valuePrefixSize}px;
    color: black;
    background-color: white;
    border-radius: 999px;
`;

export const ValueText = styled.p`
    ${styledTypography.allianceBase};
    ${styledTypography.truncate};
    ${styledTypography.textBoxTrim};
    flex: 1 1 auto;
    font-weight: 700;
    font-size: 13px;
    color: #ffffff;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: 16px;
    }
`;

export const PercentLabel = styled.div<{ $isDesc?: boolean }>`
    display: flex;
    align-items: center;
    font-size: 12px;
    font-weight: 700;
    line-height: 1;
    padding-bottom: 1px;
    color: ${({ $isDesc }) => ($isDesc ? '#ff004c' : 'rgba(98, 250, 113, 1)')};
    span {
        margin-bottom: 1px;
    }
    svg {
        width: 10px;
        height: 10px;
        fill: ${({ $isDesc }) => ($isDesc ? '#ff004c' : 'rgba(98, 250, 113, 1)')};
        transform: ${({ $isDesc }) => ($isDesc ? 'rotate(-180deg)' : 'initial')};
    }
`;
